import { render } from "./PR41-06172024.vue?vue&type=template&id=2f375166"
import script from "./PR41-06172024.vue?vue&type=script&lang=js"
export * from "./PR41-06172024.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__